import { Divider, Button, Input, Alert } from 'antd';
import React, { Suspense, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import MyInput from '../components/Input';
import MyButton from '../components/Button';
import Typography from '../components/Typography';
import { COLORS } from '../constants/Colors';
import useIsDesktop from '../utils/hooks/useIsDesktop';
import authenService from '../utils/services/authenService';
import customerService from '../utils/services/customerService';
import AppConfig from '../config';
import { useSelector, useDispatch } from 'react-redux';
import { login } from '../utils/redux/actions/authenAction';
import jwt_decode from 'jwt-decode';
import { customer_profile } from '../utils/redux/actions/customerProfileAction';
import { FormattedMessage, useIntl } from 'react-intl';

const SignInCard = () => {
  const navigate = useNavigate();
  const state = useSelector((state) => state);
  const dispatch = useDispatch();
  const isDesktop = useIsDesktop();
  const intl = useIntl();

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [checkpassword, setCheckPassword] = useState(false);

  const inputUsername = (e) => {
    setCheckPassword(false)
    setUsername(e.target.value);
  };

  const inputPassword = async (e) => {
    setCheckPassword(false)
    setPassword(e.target.value);
  };

  const signin = async () => {
    //console.log('signin');
    //console.log('store', state);
    const _authenService = new authenService();
    const body = {
      client_id: `${AppConfig.CLIENT_ID}`,
      client_secret: `${AppConfig.CLIENT_SECRET}`,
      grant_type: `${AppConfig.GRANT_TYPE_LOGIN}`,
      username: `${AppConfig.PREFIX_USERNAME}` + username,
      password: password,
    };
    await _authenService
      .login(body)
      .then(async (response) => {
        //console.log('signin response:', response);
        const decoded = jwt_decode(response.access_token);
        //console.log('signin access_token decoded:', decoded);
        dispatch(
          login(
            response.access_token,
            response.expires_in,
            response.refresh_expires_in,
            response.refresh_token,
            response.token_type,
            response.session_state,
            response.scope,
            decoded.sub,
            decoded.exp,
            username,
            password
          )
        );
        getCustomerProfile(decoded.sub, decoded.exp);
        setCheckPassword(false)
      })
      .catch((err) => {
        setCheckPassword(true)
        //console.log('signin err:', err);
      });
  };

  const getCustomerProfile = async (cusRefId, accessTokenExp) => {
    //console.log('cusRefId', cusRefId);
    const _customerService = new customerService();
    await _customerService
      .getCustomerProfile(cusRefId)
      .then((response) => {
        dispatch(customer_profile(response.data));
      })
      .catch((err) => {
        //console.log('getCustomerProfile err:', err);
      });
    navigate('/home');
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        borderRadius: '8px',
        backgroundColor: 'white',
        padding: '24px',
        paddingTop: '90px',
        justifyContent: 'center',
        width: !isDesktop ? 'auto' : '500px',
        height: '500px',
      }}
    >
      <div style={{width: '333px'}} className="d-flex flex-column">
        <Typography fontType="heading" size="36px" className="py-4 my-2">
          <FormattedMessage id='labelWelcome' defaultMessage='Welcome' />
        </Typography>
        {
          checkpassword === true ?
            <Alert message={intl.formatMessage({ id: 'validateSignIn', defaultMessage: " Username or Password Incorrect!" })} type="error" showIcon />
            : null
        }
        <MyInput
          placeHolder={intl.formatMessage({ id: 'placeholderUsernameLogin', defaultMessage: 'Username' })}
          className="mt-4"
          onChange={inputUsername}
          value={username}
        />
        <MyInput
          placeHolder={intl.formatMessage({ id: 'placeholderPasswordLogin', defaultMessage: 'Password' })}
          isPassword
          className="mt-4"
          onChange={inputPassword}
          value={password}
        />

        <MyButton isPrimary className="mt-4" onClick={signin}>
          <FormattedMessage id='btnSignIn' defaultMessage='Sign In' />
        </MyButton>
        {/* <div className="d-flex flex-row w-100 align-items-center justify-content-center py-4">
          <Typography className="px-3" size="14px">
            <FormattedMessage id='labelOr' defaultMessage='or' />
          </Typography>
      
        </div>
        <MyButton onClick={() => navigate('/register')}><FormattedMessage id='btnSignUp' defaultMessage='Sign Up' /></MyButton>
        <div className="d-flex flex-row justify-content-center pt-5">
          <Typography><FormattedMessage id='labelBottomProblem1' defaultMessage='Is there a problem?' /></Typography>
          <Typography isBold color={COLORS.Primary} className="pl-1">
            <FormattedMessage id='labelBottomProblem2' defaultMessage='Contact: 02-111-0099' />
          </Typography>
        </div> */}
      </div>
    </div>
  );
};

export default SignInCard;
